import { Grid, ListItem, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { InputNumber } from "./InputNumber";
import { SelectCustom } from "./SelectCustom";
import { SelectCustomWithOther } from "./SelectCustomWithOther";

const AUTHOR_DEFAULT = {
    autorNombres: "",
    autorApellidos: "",
    autorProcedencia: "",
    autorEmail: "",
};

export const GroupUserWorkWithFile = (props) => {

    // state para el array de autores
    const [autores, setAutores] = useState({
        trabAutores: [
            { ...AUTHOR_DEFAULT },
        ],
    });

    const { trabAutores } = autores;

    // Cuando cambia el fileupload
    const onTriggerFileChange = (event) => {    
        console.log(event);
        const { target } = event;
        const { name, value } = target;
        console.log(name, value);

        const currentWork = props.workFileName;
        const workIndex = currentWork.slice(currentWork.indexOf("-") + 1, currentWork.length) - 1;
        const workFile = { file: event.target.files[0] };

        props.workFileCallback({ workIndex, workFile });
    };
    
    // Al modificar los inputs comunes
    const onTrigger = (event) => {
        props.parentCallback(event);
    };

    // Al modificar el total de autores
    const onTriggerTotalAutores = (event) => {
        console.log(event);
        const { target } = event;
        const { name, value } = target;
        console.log(name, value);

        if (value > trabAutores.length) {
            // Se agrega un autor
            trabAutores.push({ ...AUTHOR_DEFAULT });
        } else {
            // Se elimina el ultimo autor
            trabAutores.pop();
        }

        // Enviar el array de autores para que se actualice en el parent component
        setAutores({ trabAutores });

        const currentWork = props.workTitle;
        const workIndex = currentWork.slice(currentWork.indexOf("-") + 1, currentWork.length) - 1;

        props.autoresCallback({ workIndex, trabAutores });
    };

    // Al modificar los inputs de los autores
    const onTriggerAutoresInput = (event) => {
        const { target } = event;
        const { name, value } = target;

        // Sabemos el campo y el index+1 del autor
        console.log(name, value); 

        // Lo que se ingrese se almacena en el elemento correcto del array 'autores'
        const itemName = name.slice(0, name.indexOf("-"));
        const itemIndex = name.slice(name.indexOf("-") + 1, name.length) - 1;

        trabAutores[itemIndex][itemName] = value;

        // Obtenemos el index del trabajo actual
        const currentWork = props.workTitle;
        const workIndex = currentWork.slice(currentWork.indexOf("-") + 1, currentWork.length) - 1;
        props.autoresCallback({ workIndex, trabAutores });
    };


    return (
        <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid item xs={6}>
                <SelectCustom
                    parentCallback={onTrigger}
                    name={props.workModality}
                    label={props.workModalityLabel}
                    options={props.workModalityOptions}
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={6}>
                <InputNumber
                    parentCallback={onTrigger}
                    defaultValue={1}
                    inputProps={{
                        min: 1,
                        onKeyDown: (event) => {
                            event.preventDefault();
                        },
                    }}
                    name={props.workNumParticipaciones}
                    label={props.workNumParticipacionesLabel}
                    paddingH={0}
                    paddingV={0}
                    variant={props.variant}
                    xs={12}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    defaultValue={""}
                    fullWidth
                    helperText={props.workTitleHelper}
                    id={props.workTitle}
                    label={props.workTitleLabel}
                    name={props.workTitle}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={12}>
                <SelectCustomWithOther
                    parentCallback={onTrigger}
                    name={props.workOrientation}
                    label={props.workOrientationLabel}
                    options={props.workOrientationOptions}
                    paddingH={0}
                    variant={props.variant}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    type={"file"}
                    fullWidth
                    onChange={e => onTriggerFileChange(e)}
                    helperText={props.workFileNameHelper}
                    name={"archivo"}
                    variant='standard'
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    defaultValue={""}
                    fullWidth
                    helperText={props.workKeywordsHelper}
                    id={props.workKeywords}
                    label={props.workKeywordsLabel}
                    name={props.workKeywords}
                    onChange={onTrigger}
                    required={props.required}
                    size="small"
                    variant={props.variant}
                />
            </Grid>

            {/* Total de autores */}
            <Grid item xs={12}>
                <InputNumber
                    parentCallback={onTriggerTotalAutores}
                    defaultValue={1}
                    inputProps={{
                        min: 1,
                        onKeyDown: (event) => {
                            event.preventDefault();
                        },
                    }}
                    label={props.workNumAutoresLabel}
                    name={props.workNumAutores}
                    paddingH={0}
                    paddingV={0}
                    variant={props.variant}
                    xs={6}
                />
            </Grid>
            {/* Datos de los autores */}
            <Grid item xs={12}>
                {trabAutores.map((text, index) => (
                    <ListItem key={index} disablePadding component={"span"}>
                        <Grid
                            container
                            spacing={0}
                            sx={{ m: 1, p: 1, backgroundColor: "whitesmoke" }}
                        >
                            {/* Nombres y apellidos */}
                            <Grid container spacing={2}>
                                <Grid item xs={2}>
                                    <Typography variant="h5">
                                        {index + 1}
                                        {index === 0 || index === 2 ? "er." : "o."} Autor
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorNombres-${index + 1}`}
                                        label={`Nombres | Name *`}
                                        name={`autorNombres-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={"standard"}
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorApellidos-${index + 1}`}
                                        label={`Apellidos | Last name *`}
                                        name={`autorApellidos-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={"standard"}
                                    />
                                </Grid>
                            </Grid>
                            {/* Procedencia, email */}
                            <Grid container spacing={2}>
                                <Grid item xs={7}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorProcedencia-${index + 1}`}
                                        label={`Institución de procedencia | Institution *`}
                                        name={`autorProcedencia-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={"standard"}
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        defaultValue={props.defaultValue}
                                        fullWidth
                                        id={`autorEmail-${index + 1}`}
                                        label={`Correo electrónico | Email *`}
                                        name={`autorEmail-${index + 1}`}
                                        onChange={onTriggerAutoresInput}
                                        size="small"
                                        variant={"standard"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </ListItem>
                ))}
            </Grid>
        </Grid>
    );
};
